import React from 'react'
import { ScrollView } from 'react-native'
import { S } from 'src/screens/Publishers/Versioning/VersioningPanel'

import { DNABox } from '@alucio/lux-ui'

import AssociatedFiles from './AssociatedFiles';
import SlideSettings from './SlideSettings'

const DocumentSettings: React.FC = () => {
  return (
    <ScrollView style={S.tabContentContainer}>
      <DNABox
        fill
        appearance="col"
        spacing="large"
      >
        {/* ASSOCIATED FILES */}
        <AssociatedFiles />
        {/* SLIDE SETTINGS */}
        <SlideSettings />
      </DNABox>
    </ScrollView>
  )
}

export default DocumentSettings
